import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';
import { AuthInterceptor } from './strategies/auth.interceptor';
import { ErrorHandlerInterceptor } from './strategies/error-handler.interceptor';

export const interceptors: Provider[] = [
	{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: ErrorHandlerInterceptor, multi: true },
];
